import React from 'react';
import styled, { css } from "styled-components";

type ButtonProps = {
    type: 'button' | 'submit';
    colour: 'light' | 'dark';
    text: React.ReactNode;
    id?: string;
    name?: string;
    disabled?: boolean;
    width?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    css?: React.CSSProperties;
}
type ContainerProps = {
    $colour: string;
    $width?: string;
    $disabled?: boolean;
}
const ButtonContainer = styled.button<ContainerProps>`
        float: right;
        border-radius:30px;
        font-size: 0.8rem;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: ${props => props.$colour == 'light' ? "var(--main-teal-color)" : "#FFF"};
        font-family: Lato-Black;
        background-color: ${props => props.$colour == 'light' ? " #FFF" : "var(--main-teal-color)"};
        border: ${props => props.$colour == 'light' ? "1px solid var(--main-teal-color)" : "1px solid var(--main-teal-color)"};
        width: ${props => props.$width == "full" ? "100%" : props.$width };
        box-shadow: ${props => !props.$disabled && "rgb(38, 57, 77) 0px 20px 30px -10px" };
        padding: 4px 20px 4px 20px;
        margin: 3px;
        margin-bottom: 8px;
        margin-top: 8px;
        transition: 0.3s;
            :disabled {
                  background-color: #cccccc;
                  color: #666666;
                :hover {
                    background-color: #cccccc;
                    border: none;
                    
                }
            }
            :hover {
                background-color: ${props => props.$colour == 'light' ? " var(--main-teal-color)" : "#FFF"};
                color: ${props => props.$colour == 'light' ? "#FFF" : "var(--main-teal-color)"};
                border: 1px solid var(--main-orange-color);
                transition: 0.3s;
            }
            @media (min-width: 765px) {
                margin-top: 44px;
            }
            @media (min-width: 1000px) {
                margin-top: 50px;
            }
`;

function Button({ id, name, width, type, disabled, colour, text, onClick, css }: ButtonProps) {

    return (
        // <FormGroup style={css}> {/* css={{ marginTop: "46px", float: "right" }} */}
            
            <ButtonContainer
                id={id}
                name={name}
                type={type}
                disabled={disabled}
                $disabled={disabled}
                $width={width}
                $colour={colour}
                onClick={(e: React.MouseEvent<HTMLElement>) => onClick && !disabled && onClick(e)}
                style={css}
            >{text}
            </ButtonContainer>
        // </FormGroup>
    );
}
export default Button;
